module.exports = __webpack_public_path__ + "img/b_Biofer_front.2bf1b558.jpeg";